import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricRoi extends MetricBase {
    constructor() {
        super({
            field: "metric_roas",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.roi.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.roi.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.roi.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricRoi;